export default defineNuxtRouteMiddleware((to, from) => {
  console.log("中间件检测数据:",from.path, to.path);
  const globalStore = useGlobalStore();
  if (!globalStore?.appConfig?.webSiteId && from.path !== '/launch' && from.path !== '/') {
    if(process.client){
      sessionStorage.setItem("launch", JSON.stringify({
        ptch: window.location.pathname,
        searchParams: window.location.search
      }));
    }
    // return navigateTo('/launch')
    window.location.href = '/launch'
  }
});
